import axios from 'axios';
import { find, forEach, propEq } from 'ramda';

import * as urls from 'constants/urls';

const addToDict = (id, dict) => {
    !find(propEq('id', id), dict) && dict.push({
        name: id,
        id
    });
};

export const getProducts = () => {
    return axios.get(urls.PRODUCTS.stringify()).then(data => {
        const materials = [];
        const colors = [];
        const box_counts = [];

        const func_colors = [];
        const func_groups = [];

        let minPrice = 0;
        let maxPrice = 0;

        const calcPrices = price => {
            if (!price) {
                return;
            }

            price = Number(price);

            if (minPrice > price || minPrice === 0) {
                minPrice = price;
            }
            if (maxPrice < price) {
                maxPrice = price;
            }
        };

        forEach(frame => {
            addToDict(frame.color, colors);
            addToDict(frame.material, materials);
            addToDict(frame.box_count, box_counts);

            calcPrices(frame.price);
        }, data.products.frames || []);

        forEach(func => {
            addToDict(func.color, func_colors);
            addToDict(func.func_group, func_groups);

            calcPrices(func.price);
        }, data.products.funcs || []);

        return {
            ...data,
            dicts: {
                materials,
                colors,
                box_counts,

                func_colors,
                func_groups,

                minPrice,
                maxPrice,
            },
        };
    });
};

export const getShowcases = () => axios.get(urls.SHOWCASES.stringify());
export const getProductList = () => axios.get(urls.PRODUCT_LIST.stringify());


// WEBPACK FOOTER //
// ./src/actions/httpHandlers/catalogHandlers.js